import React from 'react';
import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";
import styles from "./FAQ.scss";
import {__t} from '../../common/lang/text-resource';


class FAQ extends React.Component {
	state = {
		tabMode: 'faq'
	};
	toggleTabs = tabMode => {
		this.setState({tabMode: tabMode});
	};

	render() {
		let tabs =
		  <div>
			  <h1>{__t('Често задавани въпроси')}</h1>
			  <div>
				  <div className={styles.separator}/>
				  <Button
					value={__t("Речник на термините")}
					onClick={() => this.toggleTabs('dict')}
					name={'swith_to_faq'}
					className={buttons.buttonLink}/>
			  </div>
		  </div>;


		let links =
		  <ul>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/web-hosting.html")}
					title={__t("Какво е хостинг?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Какво е хостинг?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t('https-help-superhosting-bg-order-hosting-services3c5f13')}
					title={__t("Как да поръчам хостинг план/домейн?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Как да поръчам хостинг план/домейн?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/move-to-superhosting.html")}
					title={__t('как-да-прехвърля-домейна-и-сайта-си-при-SuperHostd340e8')}
					target="_blank"
					rel="noopener noreferrer">
					  {__t('как-да-прехвърля-домейна-и-сайта-си-при-SuperHostd340e8')}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t('https-help-superhosting-bg-time-to-activate-orderd1991a')}
					title={__t("За колко време се активира хостинг акаунта?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("За колко време се активира хостинг акаунта?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/nachini-na-plashtane.html")}
					title={__t("Какви са възможните начини на плащане?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Какви са възможните начини на плащане?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/renew.html")}
					title={__t("Как да подновя своя хостинг/домейн?")}
					target="_blank" rel="noopener noreferrer">
					  {__t("Как да подновя своя хостинг/домейн?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/domain-name.html")}
					title={__t("Какво е домейн?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Какво е домейн?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/bg-domains-faq.html")}
					title={__t("Регистрирате ли .BG домейни?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Регистрирате ли .BG домейни?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t('https-help-superhosting-bg-domain-registartion-rea1c54c')}
					title={__t("Как да регистрирам домейн?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Как да регистрирам домейн?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t('https-help-superhosting-bg-how-to-tranfser-domain89d7cc')}
					title={__t("Как да стартирам трансфер на домейн?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Как да стартирам трансфер на домейн?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t('https-help-superhosting-bg-add-parked-domain-in-c05a84c')}
					title={__t("Какво е необходимо да направя, за да 'паркирам домейн'?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Какво е необходимо да направя, за да 'паркирам домейн'?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/add-on-domain.html")}
					title={__t("Какво означава 'Add-On' домейн?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Какво означава 'Add-On' домейн?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/php.html")}
					title={__t("Кои версии на PHP поддържате?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Кои версии на PHP поддържате?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/php-modules.html")}
					title={__t("Кои модули на PHP се поддържат?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Кои модули на PHP се поддържат?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/ssl.html")}
					title={__t('какво-е-SSL-Secure-Sockets-Layer-и-мога-ли-да-пол47b560')}
					target="_blank"
					rel="noopener noreferrer">
					  {__t('какво-е-SSL-Secure-Sockets-Layer-и-мога-ли-да-пол47b560')}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/perl.html")}
					title={__t("Мога ли да ползвам Perl?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Мога ли да ползвам Perl?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/java.html")}
					title={__t("Мога ли да ползвам JAVА?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Мога ли да ползвам JAVА?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/asp-net-support.html")}
					title={__t("Поддържате ли ASP.NET хостинг?")}
					target="_blank"
					rel="noopener noreferrer">
					  {__t("Поддържате ли ASP.NET хостинг?")}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/can-create-mail-box.html")}
					title={__t('след-като-поръчам-хостинг-план-ще-мога-ли-да-си-сe98be5')}
					target="_blank"
					rel="noopener noreferrer">
					  {__t('след-като-поръчам-хостинг-план-ще-мога-ли-да-си-сe98be5')}
				  </a>
			  </li>
			  <li>
				  <a
					href={__t("https://help.superhosting.bg/calculate-mail-quota.html")}
					title={__t('колко-големи-от-към-дисковото-пространство-могат-82a9b0')}
					target="_blank"
					rel="noopener noreferrer">
					  {__t('колко-големи-от-към-дисковото-пространство-могат-82a9b0')}
				  </a>
			  </li>
		  </ul>;

		if (this.state.tabMode === 'dict') {
			tabs =
			  <div>
				  <div>
					  <Button
						value={__t("Често задавани въпроси")}
						onClick={() => this.toggleTabs('faq')}
						name={'swith_to_faq'}
						className={buttons.buttonLink}/>
				  </div>

				  <h1>
					  <div className={styles.separator}/>
					  {__t("Речник на термините")}
				  </h1>
			  </div>;

			links =
			  <ul>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/web-hosting.html")}
						title={__t("Какво е хостинг?")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("Какво е хостинг?")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/domain-name.html")}
						title={__t("Какво е домейн?")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("Какво е домейн?")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/add-on-domain.html")}
						title={__t("Какво означава 'Add-On' домейн?")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("Какво означава 'Add-On' домейн?")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/tld.html")}
						title={__t("TLD ('Top Level Domain') – Домейн от първо ниво")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("TLD ('Top Level Domain') – Домейн от първо ниво")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/domain-name-system.html")}
						title={__t("DNS ('Domain Name System')")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("DNS ('Domain Name System')")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/subdomain.html")}
						title={__t("Субдомейн ('subdomain')")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("Субдомейн ('subdomain')")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t('https-help-superhosting-bg-internet-protocol-addr474948')}
						title={__t("IP Aдрес ('Internet Protocol Address')")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("IP Aдрес ('Internet Protocol Address')")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/e-mail-box.html")}
						title={__t("Пощенска кутия ('E-mail Box')")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("Пощенска кутия ('E-mail Box')")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/mysql.html")}
						title={__t("MySQL")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("MySQL")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/ftp.html")}
						title={__t("FTP ('File Transfer Protocol')")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("FTP ('File Transfer Protocol')")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/postgresql.html")}
						title={__t("PostgreSQL")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("PostgreSQL")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/php.html")}
						title={__t("PHP")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("PHP")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t('https-help-superhosting-bg-html-hypertext-markup-bb02fc')}
						title={__t("HTML ('Hypertext Markup Language')")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("HTML ('Hypertext Markup Language')")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/account.html")}
						title={__t("Акаунт ('Account')")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("Акаунт ('Account')")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/control-panel.html")}
						title={__t("Контролен панел ('Control panel')")}
						target="_blank"
						rel="noopener noreferrer">
						  {__t("Контролен панел ('Control panel')")}
					  </a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/disk-space.html")}
						title={__t("Дисково пространство (MB)")}
						target="_blank"
						rel="noopener noreferrer">{__t("Дисково пространство (MB)")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/traffic.html")}
						title={__t("Трафик (GB)")}
						target="_blank"
						rel="noopener noreferrer">{__t("Трафик (GB)")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/parked-domain.html")}
						title={__t("Паркиран домейн")}
						target="_blank"
						rel="noopener noreferrer">{__t("Паркиран домейн")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/pop3.html")}
						title={__t("POP3 ('Post Office Protocol 3')")}
						target="_blank"
						rel="noopener noreferrer">{__t("POP3 ('Post Office Protocol 3')")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/imap.html")}
						title={__t("IMAP ('Internet Message Access Protocol')")}
						target="_blank"
						rel="noopener noreferrer">{__t("IMAP ('Internet Message Access Protocol')")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/webmail-description.html")}
						title={__t("Web MAIL")}
						target="_blank"
						rel="noopener noreferrer">{__t("Web MAIL")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/e-mail-redirection.html")}
						title={__t("E-mail пренасочване")}
						target="_blank"
						rel="noopener noreferrer">{__t("E-mail пренасочване")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/personal-error-pages.html")}
						title={__t("Персонални страници за грешки")}
						target="_blank"
						rel="noopener noreferrer">{__t("Персонални страници за грешки")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/ssh.html")}
						title={__t("SSH ('Secure Shell')")}
						target="_blank"
						rel="noopener noreferrer">{__t("SSH ('Secure Shell')")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/ssl.html")}
						title={__t("SSL ('Secure Sockets Layer')")}
						target="_blank"
						rel="noopener noreferrer">{__t("SSL ('Secure Sockets Layer')")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/c-plus-plus.html")}
						title={__t("C++ поддръжка")}
						target="_blank"
						rel="noopener noreferrer">{__t("C++ поддръжка")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/python.html")}
						title={__t("Python")}
						target="_blank"
						rel="noopener noreferrer">{__t("Python")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/ssi.html")}
						title={__t("SSI ('Server Side Includes')")}
						target="_blank"
						rel="noopener noreferrer">{__t("SSI ('Server Side Includes')")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/perl.html")}
						title={__t("Perl ('Practical Extraction and Reporting Language')")}
						target="_blank"
						rel="noopener noreferrer">{__t("Perl('Practical Extraction and Reporting Language')")}</a>
				  </li>
				  <li>
					  <a
						href={__t("https://help.superhosting.bg/wiki-pages.html")}
						title={__t("WIKI pages ('Wiki страници')")}
						target="_blank"
						rel="noopener noreferrer">{__t("WIKI pages ('Wiki страници')")}</a>
				  </li>
			  </ul>;
		}


		return (

		  <section className={styles.faq}>

			  <div className={styles.tabsContainer}>
				  {tabs}
			  </div>
			  {links}

		  </section>
		);
	}
}

export default FAQ;